export interface GraphDraftRecoveryActions {
  retry: boolean;
  adminApproval: boolean;
  standardEmailFallback: boolean;
}

export const resolveGraphDraftRecoveryActions = (input: {
  hasFeatureConfig: boolean;
  hasDraftRequest: boolean;
}): GraphDraftRecoveryActions => ({
  retry: input.hasFeatureConfig && input.hasDraftRequest,
  adminApproval: input.hasFeatureConfig,
  standardEmailFallback: input.hasDraftRequest
});
